import type {FC} from 'react';
import type {RoleScopesProvider} from '@touchnet/user-management';

import useEffectOnce from '~/hooks/use-effect-once';
import {useSelector} from "react-redux";
import Selectors from "~/state/selectors.ts";


export const ErpAdminScopesProvider: FC<RoleScopesProvider> = (props: RoleScopesProvider) => {
    const {addScope,setReady} = props;
    const cnum = useSelector(Selectors.getCustomerNumber);
    useEffectOnce(() => {
        addScope({tenantId: cnum});
        setReady(true);
    });

    return (
        <div className="flex-grow-1 d-flex align-items-center h-100">
            <div className="w-100 text-center h-100">
                <p className="lead">
                    This role has no conditions to configure. Select NEXT to proceed.
                </p>
            </div>
        </div>
    );
};

export default ErpAdminScopesProvider;
